import React from 'react';
import { Line } from 'react-chartjs-2';

class AlbumReleaseChart extends React.Component {
  render() {
    const albumReleaseYears = this.props.songs.reduce((accum, song) => {
      let year = song.album.release_date.split('-')[0];
      if (accum[year]) {
        accum[year] += 1;
        return accum;
      } else {
        accum[year] = 1;
        return accum;
      }
    }, {});
    let albumYearData = [];
    for (let year in albumReleaseYears) {
      let date = new Date();
      date.setFullYear(year);
      albumYearData.push({
        x: date,
        y: albumReleaseYears[year]
      });
    }
    const data = {
      datasets: [
        {
          label: 'Total of your top songs',
          fill: false,
          lineTension: 0.1,
          backgroundColor: 'rgba(75,192,192,0.4)',
          borderColor: 'rgba(75,192,192,1)',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: 'rgba(75,192,192,1)',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 1,
          pointHoverRadius: 5,
          pointHoverBackgroundColor: 'rgba(75,192,192,1)',
          pointHoverBorderColor: 'rgba(220,220,220,1)',
          pointHoverBorderWidth: 2,
          pointRadius: 5,
          pointHitRadius: 10,
          data: albumYearData
        }
      ]
    };
    const options = {
      tooltips: {
        callbacks: {
          title: function(tooltipItem, data) {
            return tooltipItem[0].xLabel.split(',')[1];
          }
        }
      },
      scales: {
        xAxes: [
          {
            type: 'time',
            time: {
              unit: 'year'
            }
          }
        ]
      }
    };
    return (
      <div className="sticky-top">
        <h2>By Album Release Year</h2>
        <Line options={options} data={data} />
      </div>
    );
  }
}

export default AlbumReleaseChart;
